import { Controller } from "@hotwired/stimulus"

/*
This controller uses a Stimulus "outlet" to let any element on the page interact with dropdown filter(s).
Rather than triggering any behavior itself, it exposes methods to be called using stimulus actions.

The immediate purpose is so that clicking on a tab on the students index will change the group(s) that 
are expanded/collapsed within the "Status" filter dropdown. For now this is kind of a one-off, which 
is really something we should avoid, but it's driven by UX requirements. Maybe it will get more than one 
use or maybe there is a more elegant way to hook up this kind of behavior.
*/
export default class extends Controller {
  // NOTE: the docs didn't make this clear enough: the name of the outlet HAS to match the controller 
  // it's targeting, otherwise the outlet will not get populated!
  static outlets = [ "dropdown-filter" ]

  // this needs an action parameter called "group" to be specified
  // https://stimulus.hotwired.dev/reference/actions#action-parameters
  highlightGroupByName({ params }) {
    this.dropdownFilterOutlet.highlightGroupByName(params.group);
  }
}